import { encodeExperiencesObject } from "@/utils/monetate/encodeExperiencesObject";
import styles from "./userGeneratedContent.module.scss";
import { Experiences } from "@/getServerSideProps/monetate/getExperiences/experiencesSchema";
import { Ref } from "react";
import classNames from "classnames";

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace React.JSX {
    export interface IntrinsicElements {
      "jl-user-content": {
        productid: string;
        producturl: string;
        apiKey: string;
        clientId: string;
        experiences: string;
        isBrandPromiseActive: boolean;
      };
    }
  }
}

type Props = {
  /**
   * A string representing the product ID.
   */
  productId: string;
  /**
   * A string representing the URL of the product.
   */
  productURL: string;
  /**
   * A string representing the API key.
   */
  apiKey: string;
  /**
   * A string representing the client ID.
   */
  clientId: string;
  /**
   * A string representing the raw experiences.
   */
  experiencesRawObject: Experiences;
  /**
   * A boolean indicating whether the product is a brand promise.
   */
  isBrandPromise: boolean;
  /**
   * Pulls the component up on mobile when rendered beneath the gallery.
   */
  applyMobileNegativeMarginTop?: boolean;
  onClick?: () => void;
  inViewRef?: Ref<HTMLSpanElement>;
};

export const UserGeneratedContentUI = ({
  productId,
  productURL,
  apiKey,
  clientId,
  experiencesRawObject,
  isBrandPromise,
  applyMobileNegativeMarginTop = true,
  onClick,
  inViewRef,
}: Props) => (
  <div
    id="user-generated-content"
    data-testid="userGeneratedContent"
    className={classNames(
      styles.container,
      applyMobileNegativeMarginTop && styles.mobileNegativeMarginTop,
    )}
    onClick={onClick}
    data-component="UserGeneratedContent"
  >
    <span
      ref={inViewRef}
      className={styles.inViewMarker}
      data-testid="ugc-in-view-marker"
      aria-hidden="true"
    />
    <jl-user-content
      productid={productId}
      producturl={productURL}
      apiKey={apiKey}
      clientId={clientId}
      experiences={
        experiencesRawObject
          ? encodeExperiencesObject(experiencesRawObject)
          : ""
      }
      isBrandPromiseActive={isBrandPromise}
    ></jl-user-content>
  </div>
);
